export const groupsTranslationNL = {
    title: "Groepen",
    fields: {
        name: "Naam",
    },
};
